// Ensure global toggle function exists for dynamically injected upsell snippet
if (!window.toggleUpsellContent) {
  window.toggleUpsellContent = function(header) {
    try {
      const upsell = header.closest('.cart-upsell');
      if (!upsell) return;
      const content = upsell.querySelector('.cart-upsell__content');
      const toggle = upsell.querySelector('.cart-upsell__toggle');
      if (!content) return;
      const isHidden = content.style.display === 'none' || content.style.display === '';
      if (isHidden) {
        content.style.display = 'block';
        toggle && toggle.classList.add('rotated');
        upsell.classList.add('expanded');
      } else {
        content.style.display = 'none';
        toggle && toggle.classList.remove('rotated');
        upsell.classList.remove('expanded');
      }
    } catch (e) {
      console.error('toggleUpsellContent error', e);
    }
  }
}

class CartCheckboxUpsell {
  constructor(cartItemsInstance) {
    this.cartItemsInstance = cartItemsInstance;
    this.baseUrl = "/cart";
    this.checkboxUpsellVariantId = this.getUpsellCheckboxVariantId();
    this.isUpdating = false;
    this.hasInitialized = false;
    this.isRemovingOrphans = false;
    this.isGiftCardOnly = false;
    this.lastCartItemCount = null;
    this.initEventDelegation();
    document.addEventListener("cartUpdated", this.handleCartUpdate.bind(this));
    this.updateCheckboxState();
  }

  initEventDelegation() {
    document.body.removeEventListener("change", this.handleCheckboxChange);

    this.handleCheckboxChange = (event) => {
      if (event.target.id === "cart-upsell-checkbox" && !this.isUpdating) {
        this.isUpdating = true;
        this.showLoadingSpinner();
        const isChecked = event.target.checked;
        if (isChecked) {
          this.addUpsellCheckboxToCart();
        } else {
          this.removeUpsellCheckboxFromCart();
        }
        setTimeout(() => {
          this.isUpdating = false;
        }, 1000);
      }
    };

    document.body.addEventListener("change", this.handleCheckboxChange);
  }

  showLoadingSpinner() {
    const loadingSpinner = document.querySelector('.cart-upsell__loading');
    if (loadingSpinner) loadingSpinner.classList.remove('hidden');
  }

  hideLoadingSpinner() {
    const loadingSpinner = document.querySelector('.cart-upsell__loading');
    if (loadingSpinner) loadingSpinner.classList.add('hidden');
  }

  getUpsellCheckboxVariantId() {
    return document
      .querySelector("#cart-upsell-checkbox")
      ?.getAttribute("data-variant-id");
  }

cartContainsOnlyGiftCards(cartItems) {
  if (!cartItems || cartItems.length === 0) return false;
  const nonUpsellItems = cartItems.filter(item => 
    item.variant_id.toString() !== this.checkboxUpsellVariantId &&
    !item.properties?._fast_processing &&
    item.properties?._is_hidden_upsell !== 'true'
  );
  if (nonUpsellItems.length === 0) return false;
  return nonUpsellItems.every(item => item.product_type === 'Gift Card' || item.gift_card === true);
}

  updateCheckboxState() {
    this.checkboxUpsellVariantId = this.getUpsellCheckboxVariantId();

    return fetch(`${this.baseUrl}.js`)
      .then((response) => response.json())
      .then((cart) => {
        const currentItemCount = cart.items?.length || 0;
        const wasPreviouslyEmpty = this.lastCartItemCount === 0 || this.lastCartItemCount === null;

        // Always sync widget visibility
        const upsellWidget = document.querySelector('.cart-upsell');
        if (upsellWidget) {
          upsellWidget.style.display = this.cartContainsOnlyGiftCards(cart.items) ? 'none' : '';
        }

        // --- GIFT CARD HANDLING ---
        if (this.cartContainsOnlyGiftCards(cart.items)) {
          // Remove VIP upsell from cart if present
          const upsellItem = cart.items.find(
            item => item.variant_id.toString() === this.checkboxUpsellVariantId
          );
          if (upsellItem) {
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: { [upsellItem.key]: 0 } })
            }).then(() => {
              if (this.cartItemsInstance && typeof this.cartItemsInstance.onCartUpdate === 'function') {
                this.cartItemsInstance.onCartUpdate();
              }
            });
          }

          // Set flag so handleCartUpdate skips processing on the next cartUpdated event,
          // then uncheck the checkbox once the DOM has re-rendered
          this.isGiftCardOnly = true;
          const uncheckOnce = () => {
            document.removeEventListener('cartUpdated', uncheckOnce);
            this.isGiftCardOnly = false;
            document.body.removeEventListener('change', this.handleCheckboxChange);
            const checkbox = document.querySelector('#cart-upsell-checkbox');
            if (checkbox) checkbox.checked = false;
            setTimeout(() => {
              document.body.addEventListener('change', this.handleCheckboxChange);
            }, 50);
          };
          document.addEventListener('cartUpdated', uncheckOnce);

          this.lastCartItemCount = currentItemCount;
          return;
        }

        // --- NORMAL CART HANDLING ---
        const hasUpsellCheckbox = cart.items.some(
          (item) => item.variant_id.toString() === this.checkboxUpsellVariantId
        );
        const checkboxUpsellCheckbox = document.querySelector("#cart-upsell-checkbox");

        // If cart is empty, reset checkbox to default checked state
        if (currentItemCount === 0) {
          if (checkboxUpsellCheckbox) {
            document.body.removeEventListener("change", this.handleCheckboxChange);
            checkboxUpsellCheckbox.checked = true;
            setTimeout(() => {
              document.body.addEventListener("change", this.handleCheckboxChange);
            }, 50);
          }
        }

        // Transition from empty -> first item: force check and auto-add upsell
        if (wasPreviouslyEmpty && currentItemCount > 0) {
          if (checkboxUpsellCheckbox) {
            document.body.removeEventListener("change", this.handleCheckboxChange);
            if (!checkboxUpsellCheckbox.checked) checkboxUpsellCheckbox.checked = true;
            setTimeout(() => {
              document.body.addEventListener("change", this.handleCheckboxChange);
            }, 50);
          }

          if (!hasUpsellCheckbox && checkboxUpsellCheckbox && checkboxUpsellCheckbox.checked) {
            this.addUpsellCheckboxToCart();
          }
        }

        if (checkboxUpsellCheckbox) {
          // Initial load: auto-add upsell if checkbox is checked and upsell not in cart
          if (!this.hasInitialized && checkboxUpsellCheckbox.checked && !hasUpsellCheckbox && currentItemCount > 0) {
            this.hasInitialized = true;
            this.addUpsellCheckboxToCart();
            this.lastCartItemCount = currentItemCount;
            return;
          }

          // Subsequent updates: sync checkbox with actual cart state
          if (this.hasInitialized && checkboxUpsellCheckbox.checked !== hasUpsellCheckbox) {
            document.body.removeEventListener("change", this.handleCheckboxChange);
            checkboxUpsellCheckbox.checked = hasUpsellCheckbox;
            setTimeout(() => {
              document.body.addEventListener("change", this.handleCheckboxChange);
            }, 50);
          }

          this.hasInitialized = true;
        }

        this.lastCartItemCount = currentItemCount;
      })
      .catch((error) => {
        console.error("Error fetching cart:", error);
      });
  }

  handleCartUpdate() {
    if (this.isRemovingOrphans) return;
    if (this.isGiftCardOnly) return; // Let uncheckOnce handle this cartUpdated event

    if (this.updateTimeout) clearTimeout(this.updateTimeout);

    this.updateTimeout = setTimeout(() => {
      if (!this.isUpdating) {
        this.checkAndRemoveOrphanedUpsell().then(() => {
          this.updateCheckboxState();
        });
      }
    }, 500);
  }

  async checkAndRemoveOrphanedUpsell() {
    if (this.isRemovingOrphans) return;

    try {
      const response = await fetch(`${this.baseUrl}.js`);
      const cart = await response.json();

      if (!cart.items || cart.items.length === 0) return;

      // If only gift cards remain, let updateCheckboxState handle cleanup
      if (this.cartContainsOnlyGiftCards(cart.items)) return;

      // Remove orphaned fast-processing items
      const onlyFastProcessing = cart.items.every(item => {
        const fp = item.properties?._fast_processing;
        return fp === true || fp === 'true' || String(fp).toLowerCase() === 'true';
      });

      if (onlyFastProcessing) {
        this.isRemovingOrphans = true;
        const updates = {};
        cart.items.forEach(item => { updates[item.key] = 0; });

        const updateResponse = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });

        if (updateResponse.ok) {
          if (this.cartItemsInstance && typeof this.cartItemsInstance.onCartUpdate === "function") {
            this.cartItemsInstance.onCartUpdate();
          }
        }

        setTimeout(() => { this.isRemovingOrphans = false; }, 1000);
      }
    } catch (error) {
      console.error('Error checking for orphaned upsell items:', error);
      this.isRemovingOrphans = false;
    }
  }

  addUpsellCheckboxToCart() {
    this.checkboxUpsellVariantId = this.getUpsellCheckboxVariantId();
    if (!this.checkboxUpsellVariantId) {
      console.warn("Cart upsell variant id not found. Skipping add.");
      return;
    }
    const formData = new FormData();
    formData.append("id", this.checkboxUpsellVariantId);
    formData.append("quantity", 1);

    if (window.theme?.settings?.cart_upsell_fast_processing) {
      formData.append("properties[_fast_processing]", "true");
    }

    fetch(`${this.baseUrl}/add.js`, {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        this.hideLoadingSpinner();
        if (response.ok) {
          if (this.cartItemsInstance && typeof this.cartItemsInstance.onCartUpdate === "function") {
            this.cartItemsInstance.onCartUpdate();
          }
          this.onCartUpdateCheckboxUpsell();
        }
        return response.json();
      })
      .catch((error) => {
        this.hideLoadingSpinner();
        console.error("Error adding cart upsell:", error);
      });
  }

  removeUpsellCheckboxFromCart() {
    this.checkboxUpsellVariantId = this.getUpsellCheckboxVariantId();
    if (!this.checkboxUpsellVariantId) {
      console.warn("Cart upsell variant id not found. Skipping remove.");
      return;
    }
    const updates = {};

    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        cart.items.forEach((item) => {
          if (item.variant_id.toString() === this.checkboxUpsellVariantId) {
            updates[item.key] = 0;
          }
        });

        if (Object.keys(updates).length > 0) {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          });
        } else {
          console.error("Cart upsell product not found in cart.");
          return Promise.reject("Product not found");
        }
      })
      .then((response) => {
        this.hideLoadingSpinner();
        if (response && response.ok) {
          if (this.cartItemsInstance && typeof this.cartItemsInstance.onCartUpdate === "function") {
            this.cartItemsInstance.onCartUpdate();
          }
          this.onCartUpdateCheckboxUpsell();
        }
        return response ? response.json() : null;
      })
      .catch((error) => {
        this.hideLoadingSpinner();
        console.error("Error removing cart upsell:", error);
      });
  }

  getSectionsToRenderCheckboxUpsell() {
    const mainCartFooter = document.getElementById("main-cart-footer");
    return [
      ...(mainCartFooter ? [{
        id: "main-cart-footer",
        section: mainCartFooter.dataset.id,
        selector: "#main-cart-footer .js-contents",
      }] : []),
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: "#cart-icon-bubble",
      },
    ];
  }

  onCartUpdateCheckboxUpsell() {
    this.getSectionsToRenderCheckboxUpsell().forEach((section) => {
      fetch(`${this.baseUrl}?section_id=${section.section}`)
        .then((response) => response.text())
        .then((html) => {
          const container = document.querySelector(section.selector);
          if (!container) {
            console.error(`Container not found for selector: ${section.selector}`);
            return;
          }
          if (section.id === "main-cart-footer") {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const jsContents = doc.querySelector(".js-contents");
            if (jsContents) {
              container.innerHTML = jsContents.innerHTML;
            }
          } else if (section.id === "cart-icon-bubble") {
            container.innerHTML = html;
          }
        })
        .catch((error) => console.error(`Error updating section ${section.id}:`, error));
    });
  }
}

window.CartCheckboxUpsell = CartCheckboxUpsell;

document.addEventListener("DOMContentLoaded", function () {
  initializeCartCheckboxUpsell();
});

function initializeCartCheckboxUpsell() {
  const cartItemsInstance = document.querySelector("cart-items");
  const cartDrawerItemsInstance = document.querySelector("cart-drawer-items");
  const activeCartInstance = cartDrawerItemsInstance || cartItemsInstance;

  if (activeCartInstance && !window.cartCheckboxUpsellInstance) {
    window.cartCheckboxUpsellInstance = new CartCheckboxUpsell(activeCartInstance);
  } else if (!activeCartInstance) {
    console.log("Neither cart-items nor cart-drawer-items found in the DOM.");
  }
}